module.exports = __webpack_public_path__ + "static/media/Homeherodesktop.348d781e.png";